// @flow
// $FlowFixMe
import {useEffect} from 'react';
import {createBrowserHistory} from 'history';

export const history = createBrowserHistory();

type GoToPathname = (pathname: string) => void;

//
// useHistorySync allows changes in history to call a callback
// it ignores changes that don't come directly from browser history interactions
//

export const useHistorySync = (goToPathname: GoToPathname) => {
    useEffect(() => {
        goToPathname(document.location.pathname);
        history.listen((location, method) => {
            // only drive state machine for changes that come from browser navigation a.k.a. POP
            if(method === 'POP') {
                goToPathname(location.pathname);
            }
        });
    }, []);
};

//
// historyPush pushes alocation into history
// in a way that does not cause any infinite loops when used in conjunction with useHistorySync
//

export const historyPush = (pathname: string, replace = false, params = {}) => {
    if(document.location.pathname !== pathname) {
        const searchParams = new URLSearchParams(document.location.search);

        // remove email and username as these are only used once at sign up
        // all other search params should be retained
        searchParams.delete('email');
        searchParams.delete('username');
        // Remove oAuth codes from the URL
        searchParams.delete('code');
        Object.keys(params).forEach((key) => {
            searchParams.append(key, params[key]);
        });

        const pushParams = {
            pathname,
            search: searchParams.toString()
        };

        replace
            ? history.replace(pushParams)
            : history.push(pushParams);
    }
};